import { useState } from 'react';

import type { Task } from '@klareospace/pharos-lib-types';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface UseTaskDetailDialogReturn {
  /** Closes the task detail dialog. */
  closeTaskDetail: () => void;
  /** Whether the task detail dialog should be shown. */
  isTaskDetailOpen: boolean;
  /** Opens the dialog for the given task; also used to refresh it after a successful assignment mutation. */
  openTaskDetail: (task: Task) => void;
  /** The task currently shown in the dialog, or null when closed. */
  selectedTask: Task | null;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

/** Open/close state for the Task Detail modal, rendered as a sibling of the order `SideDrawer`. */
export function useTaskDetailDialog(): UseTaskDetailDialogReturn {
  const [selectedTask, setSelectedTask] = useState<Task | null>(null);

  return {
    closeTaskDetail: (): void => setSelectedTask(null),
    isTaskDetailOpen: selectedTask !== null,
    openTaskDetail: (task: Task): void => setSelectedTask(task),
    selectedTask,
  };
}
